var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.78724,
    height: 1.84716,
    transform: "matrix(-0.699113 0.715011 0.699113 0.715011 6.84229 0.00012207)",
    fill: "#ffecb3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.77298,
    height: 1.84716,
    transform: "matrix(0.699113 0.715011 -0.699113 0.715011 1.30054 5.69141)",
    fill: "#ffecb3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.28906,
    y: 6,
    width: 12.711,
    height: 2,
    fill: "#ffecb3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5b80fcfbb18dac16da57acb551fc6fb3.svg";
export { ForwardRef as ReactComponent };